/** 固件库 / OTA 包：各环境统一走生产 hub（与 BUILD_ENV 无关） */
const FIRMWARE_PROD_ORIGIN_BY_BRAND: Record<string, string> = {
  eweadn: "https://new-hub.eweadn.cn",
  exx: "https://exx-hub.eweadn.cn",
};

function firmwareProdOrigin(): string {
  const brand =
    typeof process !== "undefined" && process.env.BRAND
      ? String(process.env.BRAND).toLowerCase()
      : "eweadn";
  return (
    FIRMWARE_PROD_ORIGIN_BY_BRAND[brand] ?? FIRMWARE_PROD_ORIGIN_BY_BRAND.eweadn
  );
}

/** 固件相关 API 根路径（含 `/api`） */
export function getFirmwareApiBaseUrl(): string {
  return `${firmwareProdOrigin()}/api`;
}

/**
 * OTA 固件包文件 URL（bin / versions.json / exe）。
 * 路径段单独 encode，避免空格、中文等破坏 URL。
 */
export function getFirmwareFileUrl(...parts: string[]): string {
  const segments = parts.flatMap((part) =>
    String(part || "")
      .replace(/\\/g, "/")
      .split("/")
      .filter(Boolean)
  );
  return `${getFirmwareApiBaseUrl()}/v1/firmware-package/files/${segments
    .map((segment) => encodeURIComponent(segment))
    .join("/")}`;
}
